import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EnergyEfficiencyLabel } from '~shared/modules/product-card/models/energy-efficiency-label.enum';
import { environment } from '~env/environment';
import { EecModalService } from '~app/modules/product/services/eec-modal.service';
import { EnergyEfficiencyVersion } from '~shared/modules/product-card/models/energy-efficiency-version.enum';

@Component({
  selector: 'app-search-product-energy-efficiency',
  templateUrl: './product-energy-efficiency.component.html',
  styleUrls: ['./product-energy-efficiency.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductEnergyEfficiencyComponent implements OnChanges {
  @Input() energyEfficiencyImage: string;
  @Input() energyEfficiencyColor: string; // this EEC Color is only used for OLD labels
  @Input() energyEfficiencyLabel: EnergyEfficiencyLabel;
  @Input() energyEfficiencyVersion: EnergyEfficiencyVersion;
  @Input() showEnergyScale?: boolean;

  energyEfficiencyLabelImage: string; // this EEC Image is only used for NEW labels
  isNewEnergyEfficiencyVersion: boolean;

  constructor(
    private energyEfficiencyModalService: EecModalService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.energyEfficiencyLabel || !this.energyEfficiencyVersion) {
      return;
    }

    if (this.showEnergyScale) {
      this.energyEfficiencyLabelImage
        = `${environment.cdnBaseUrl()}/images/energy-efficiency-labels/ovens_energy_label_${this.energyEfficiencyLabel}.svg`;
      return;
    }

    this.isNewEnergyEfficiencyVersion = this.isNewEnergyEfficiencyLabel(this.energyEfficiencyLabel)
      && this.energyEfficiencyVersion === EnergyEfficiencyVersion.NEW_VERSION;
    if (this.isNewEnergyEfficiencyVersion) {
      this.energyEfficiencyLabelImage =
        `${environment.cdnBaseUrl()}/images/energy-efficiency-labels/${this.energyEfficiencyLabel}.svg`;
    }
  }

  onEnergyEfficiencyLabelClick(event): void {
    if (!this.energyEfficiencyImage) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();
    this.energyEfficiencyModalService.openEecDocument(this.energyEfficiencyImage);
  }

  isNewEnergyEfficiencyLabel(label: EnergyEfficiencyLabel): boolean {
    return label !== EnergyEfficiencyLabel.aPlus && label !== EnergyEfficiencyLabel.aPlusPlus
      && label !== EnergyEfficiencyLabel.aPlusPlusPlus;
  }
}
